import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-all duration-200",
  {
    variants: {
      variant: {
        default:
          "bg-info-soft text-info-text border border-info/20",
        secondary:
          "bg-muted text-muted-foreground border border-border",
        success:
          "bg-success-soft text-success-text border border-success/20",
        warning:
          "bg-warning-soft text-warning-text border border-warning/20",
        destructive:
          "bg-error-soft text-error-text border border-error/20",
        outline:
          "border border-border text-foreground",
        gold:
          "bg-warning-soft text-warning-text border border-warning/20",
        silver:
          "bg-muted/10 text-muted-foreground dark:bg-slate-400/10 dark:text-muted-foreground border border-slate-500/20",
        bronze:
          "bg-warning-soft text-warning-text dark:bg-orange-400/20 dark:text-orange-400 border border-warning/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
